function toggleFromList(list, value) {
    const result = Object.assign([], list);
    const idx = result.indexOf(value);
    if (idx === -1)
        result.push(value);
    else
        result.splice(idx, 1);
    return result;
}
function objToBase64(obj) {
    return new Buffer(JSON.stringify(obj)).toString('base64');
}
function base64ToObj(b64Str) {
    if (!b64Str)
        return null;
    return JSON.parse(new Buffer(b64Str, 'base64').toString('ascii'));
}
export function areShipmentsHaveSameShipper(shipments) {
    return shipments.every((shipment) => {
        if (!Object.hasOwn(shipment, 'shipper')) {
            return false;
        }
        const shipperId = shipment.shipper._id || shipment.shipper.id;
        const firstShipperId = shipments[0].shipper._id || shipment.shipper.id;
        return !!shipperId && shipperId === firstShipperId;
    });
}
export default {
    toggleFromList,
    objToBase64,
    base64ToObj,
};
